/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Loading_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Loading clipboard content" |
*
* @param {Paste_Attributes_Loading_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_loading_aria_label = /** @type {((inputs?: Paste_Attributes_Loading_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Loading_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du contenu du presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalt der Zwischenablage wird geladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento del contenuto degli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка содержимого буфера обмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando contenido del portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载剪贴板内容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリップボードの内容を読み込み中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लिपबोर्ड की सामग्री लोड हो रही है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando conteúdo da área de transferência")
	return /** @type {LocalizedString} */ ("Loading clipboard content")
});